import { Component, Input, OnInit, input } from '@angular/core';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';

@Component({
    selector: 'app-content-header',
    templateUrl: './content-header.component.html',
    styleUrl: './content-header.component.scss',
    imports: [NzGridModule, NzAvatarModule]
})
export class ContentHeaderComponent implements OnInit {
	@Input() header: any;
	readonly cvId = input<number>();
	readonly settings = input<any>();
	readonly latestJobTitle = input<string>();

	public isProfilePhotoView: boolean;
	public isFirstNameView: boolean;
	public isLastNameView: boolean;
	public isCSUsernameView: boolean;
	public isJXIDView: boolean;
	public isJobseekingstatusView: boolean;
	public isCloudstaffDomain: boolean = true;

	ngOnInit(): void {
		this.isCloudstaffDomain =  window.location.href?.toString()?.includes('cloudstaff.com');
		const settings = this.settings();
  this.isProfilePhotoView = settings
			?.filter((e: any) => e.name == 'Profile Photo')
			.map((e: any) => e.active)[0];
		this.isFirstNameView = settings
			?.filter((e: any) => e.name == 'First Name')
			.map((e: any) => e.active)[0];
		this.isLastNameView = settings
			?.filter((e: any) => e.name == 'Last Name')
			.map((e: any) => e.active)[0];
		this.isCSUsernameView = settings
			?.filter((e: any) => e.name == 'CS Username')
			.map((e: any) => e.active)[0];
		this.isJXIDView = settings
			?.filter((e: any) => e.name == 'JX-ID')
			.map((e: any) => e.active)[0];
		this.isJobseekingstatusView = settings
			?.filter((e: any) => e.name == 'Job seeking status')
			.map((e: any) => e.active)[0];
	}
}
